import React, { Component } from 'react';
import LandingPanel from "../landingPagePanel/landingPagePanel";
import LandingSidebar from '../landingSidebar/landingSidebar';

const llmSidebarLinks = [
    {label: 'Overview', to: '/llm'},
];

class LLMLanding extends Component{

    constructor(props){
        super(props);
        this.gettingStartedTutorials = [
                {id: 1,
                    title: 'Getting started',
                    content: 'What are Large Language Models',
                    image:"/images/machine-learning/panel-llm-getting-started.svg",
                    slug:'getting-started',
                    enabled: false},
                {id: 2,
                    title: 'How LLMs actually work',
                    content: 'From input tokens to predicted output, step by step.',
                    image:"/images/machine-learning/panel-llm-how-llms-work.svg",
                    slug:'how-do-llms-work',
                    enabled: false},
                {id: 3,
                    title: 'Using an LLM locally',
                    content: 'Run an LLM on your own machine.',
                    image:"/images/machine-learning/panel-llm-local.svg",
                    slug:'getting-started-locally',
                    enabled: false},
                {id: 4,
                    title: 'LLM tokens',
                    content: 'How text gets broken into the pieces a model reads.',
                    image:"/images/machine-learning/panel-llm-tokens.svg",
                    slug:'llm-tokens',
                    enabled: false},
                {id: 5,
                    title: 'The context window',
                    content: 'How much text a model can pay attention to at once.',
                    image:"/images/machine-learning/panel-llm-context-window.svg",
                    slug:'context-window',
                    enabled: false},
                {id: 6,
                    title: 'Self-attention',
                    content: 'How a model weighs one token against every other.',
                    image:"/images/machine-learning/panel-llm-self-attention.svg",
                    slug:'self-attention',
                    enabled: false},
                {id: 7,
                    title: 'The KV cache',
                    content: "Why generation gets faster once the prompt is processed.",
                    image:"/images/machine-learning/panel-llm-kv-cache.svg",
                    slug:'kv-cache',
                    enabled: false},
                {id: 8,
                    title: 'Mixture of experts',
                    content: 'Routing each token to a handful of specialised sub-networks.',
                    image:"/images/machine-learning/panel-llm-mixture-of-experts.svg",
                    slug:'mixture-of-experts',
                    enabled: false},
                {id: 9,
                    title: 'LLMs and reasoning',
                    content: "Chain-of-thought, and how models \"think\" before answering.",
                    image:"/images/machine-learning/panel-llm-reasoning.svg",
                    slug:'reasoning',
                    enabled: false},
                {id: 10,
                    title: 'Retrieval-augmented generation',
                    content: 'Grounding answers in documents retrieved at query time.',
                    image:"/images/machine-learning/panel-llm-rag.svg",
                    slug:'rag',
                    enabled: false},
            ];

        this.mainLlms = [
                {id: 1,
                    title: 'GPT',
                    content: "OpenAI's GPT family, from ChatGPT to the GPT-4/5 models.",
                    image:"/images/machine-learning/panel-llm-gpt.svg",
                    slug:'gpt',
                    enabled: false},
                {id: 2,
                    title: 'Claude',
                    content: "Anthropic's Claude family of models.",
                    image:"/images/machine-learning/panel-llm-claude.svg",
                    slug:'claude',
                    enabled: false},
                {id: 3,
                    title: 'Gemini',
                    content: "Google's Gemini family, integrated across Google's products.",
                    image:"/images/machine-learning/panel-llm-gemini.svg",
                    slug:'gemini',
                    enabled: false},
                {id: 4,
                    title: 'Llama',
                    content: "Meta's family of openly available models.",
                    image:"/images/machine-learning/panel-llm-llama-model.svg",
                    slug:'llama',
                    enabled: false},
                {id: 5,
                    title: 'Mistral',
                    content: 'Open-weight models from Mistral AI.',
                    image:"/images/machine-learning/panel-llm-mistral.svg",
                    slug:'mistral',
                    enabled: false},
                {id: 6,
                    title: 'DeepSeek',
                    content: 'Open-weight, reasoning-focused models from DeepSeek.',
                    image:"/images/machine-learning/panel-llm-deepseek.svg",
                    slug:'deepseek',
                    enabled: false},
            ];

        this.runningLocallyTutorials = [
                {id: 1,
                    title: 'Running Ollama locally',
                    content: 'The easiest way to run open-weight models on your own machine.',
                    image:"/images/machine-learning/panel-llm-ollama.svg",
                    slug:'running-ollama-locally',
                    enabled: false},
                {id: 2,
                    title: 'Configuring a local LLM',
                    content: 'System prompts, settings, and picking the right model.',
                    image:"/images/machine-learning/panel-llm-config.svg",
                    slug:'configure-a-locally-running-llm',
                    enabled: false},
                {id: 3,
                    title: 'Challenges of running locally',
                    content: 'Hardware limits and the trade-offs of going local.',
                    image:"/images/machine-learning/panel-llm-challenges.svg",
                    slug:'challenges-of-running-llm-locally',
                    enabled: false},
                {id: 4,
                    title: 'Building a JARVIS-style assistant',
                    content: 'Combining a local LLM with voice and automation.',
                    image:"/images/machine-learning/panel-llm-voice-assistant.svg",
                    slug:'create-a-jarvis-style-assistant',
                    enabled: false},
                {id: 5,
                    title: 'llama.cpp',
                    content: 'The fast, lightweight C/C++ inference engine many local tools are built on.',
                    image:"/images/machine-learning/panel-llm-llamacpp.svg",
                    slug:'llama-cpp',
                    enabled: false},
                {id: 6,
                    title: 'vLLM',
                    content: 'A high-throughput engine for serving models efficiently on your own GPU.',
                    image:"/images/machine-learning/panel-llm-vllm.svg",
                    slug:'vllm',
                    enabled: false},
                {id: 7,
                    title: 'LM Studio',
                    content: 'A desktop app for running models through a graphical interface.',
                    image:"/images/machine-learning/panel-llm-studio.svg",
                    slug:'lm-studio',
                    enabled: false},
            ];

        this.tuningTutorials = [
                {id: 1,
                    title: 'LoRA & QLoRA fine-tuning',
                    content: 'Training a small adapter instead of the whole model.',
                    image:"/images/machine-learning/panel-llm-lora.svg",
                    slug:'lora-qlora-fine-tuning',
                    enabled: false},
                {id: 2,
                    title: 'Unsloth',
                    content: 'Faster, lower-memory fine-tuning for open-weight models.',
                    image:"/images/machine-learning/panel-llm-unsloth.svg",
                    slug:'unsloth',
                    enabled: false},
                {id: 3,
                    title: 'Preparing a fine-tuning dataset',
                    content: 'Turning your own examples into training data.',
                    image:"/images/machine-learning/panel-llm-dataset.svg",
                    slug:'preparing-a-fine-tuning-dataset',
                    enabled: false},
                {id: 4,
                    title: 'Quantization',
                    content: 'Shrinking a model to run faster with less memory.',
                    image:"/images/machine-learning/panel-llm-quantization.svg",
                    slug:'quantization',
                    enabled: false},
                {id: 5,
                    title: 'Custom Modelfiles',
                    content: "Layering your own system prompt and settings onto a base model.",
                    image:"/images/machine-learning/panel-llm-modelfile.svg",
                    slug:'custom-modelfiles',
                    enabled: false},
                {id: 6,
                    title: 'Merging models',
                    content: 'Combining fine-tuned models and adapters into one.',
                    image:"/images/machine-learning/panel-llm-merge.svg",
                    slug:'merging-models',
                    enabled: false},
            ];
    }


    render(){

        return (
            <React.Fragment>
                <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full">
                    <LandingSidebar title="Large Language Models" links={llmSidebarLinks}/>
                    <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10 pb-24">
                <div
                    className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-red-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                    <path
                                        d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8"
                                        stroke="#222222" strokeWidth="1.2" opacity="0.5"/>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Getting started
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">A gentle introduction to LLM's
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.gettingStartedTutorials.map((data) => (
                                <LandingPanel key={data.id} title={data.title} imageSource={data.image}
                                              enabled={data.enabled}
                                              to={"/llm/basics/" + data.slug}
                                              strapLine={data.content}/>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-blue-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                    <path
                                        d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8"
                                        stroke="#222222" strokeWidth="1.2" opacity="0.5"/>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Main LLMs
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">Some of the most widely used model families
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.mainLlms.map((data) => (
                                <LandingPanel key={data.id} title={data.title} imageSource={data.image}
                                              enabled={data.enabled}
                                              to={"/llm/models/" + data.slug}
                                              strapLine={data.content}/>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-green-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                    <path
                                        d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8"
                                        stroke="#222222" strokeWidth="1.2" opacity="0.5"/>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Running an LLM locally
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">Set up and run models on your own hardware
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.runningLocallyTutorials.map((data) => (
                                <LandingPanel key={data.id} title={data.title} imageSource={data.image}
                                              enabled={data.enabled}
                                              to={"/llm/running-locally/" + data.slug}
                                              strapLine={data.content}/>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-purple-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                    <path
                                        d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8"
                                        stroke="#222222" strokeWidth="1.2" opacity="0.5"/>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Fine-tuning and customizing locally
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">Adapt a model to your own data and use case
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.tuningTutorials.map((data) => (
                                <LandingPanel key={data.id} title={data.title} imageSource={data.image}
                                              enabled={data.enabled}
                                              to={"/llm/fine-tuning/" + data.slug}
                                              strapLine={data.content}/>
                            ))}
                        </div>
                    </div>
                </div>
                    </section>
                </div>
            </React.Fragment>
        )
    };

}

export default LLMLanding;
